var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Namibia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1a237e",
    d: "M24,4C12.954,4,4,12.954,4,24c0,1.585,0.204,3.119,0.552,4.597l30.534-21.24 C31.912,5.239,28.102,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M44,24c0-1.585-0.204-3.119-0.552-4.597l-30.534,21.24C16.088,42.761,19.898,44,24,44 C35.046,44,44,35.046,44,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.086,7.357L4.552,28.597c0.216,0.916,0.493,1.806,0.83,2.668l31.9-22.19 C36.587,8.457,35.862,7.875,35.086,7.357z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.618,16.735l-31.9,22.19c0.694,0.618,1.42,1.201,2.196,1.719l30.534-21.24 C43.232,18.487,42.955,17.597,42.618,16.735z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M37.281,9.076l-31.9,22.19c1.158,2.965,3,5.578,5.337,7.659l31.9-22.19 C41.46,13.77,39.618,11.156,37.281,9.076z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M19.047,13.781L21,13l-1.945-0.777l1.336-1.613l-2.262,0.27l0.277-2.262l-1.625,1.336L16,8 l-0.777,1.945l-1.613-1.336l0.27,2.262l-2.262-0.277l1.336,1.625L11,13l1.945,0.777l-1.336,1.613l2.262-0.27l-0.277,2.262 l1.625-1.336L16,18l0.777-1.945l1.613,1.336l-0.27-2.262l2.262,0.277L19.047,13.781z M16,16c-1.656,0-3-1.344-3-3s1.344-3,3-3 s3,1.344,3,3S17.656,16,16,16z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M18,13c0,1.105-0.895,2-2,2s-2-0.895-2-2s0.895-2,2-2S18,11.895,18,13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Namibia);
export default __webpack_public_path__ + "static/media/icons8-namibia.7cb6f15a633474ae8599936756909937.svg";
export { ForwardRef as ReactComponent };